import { createBasicSelectors } from 'store/utils'
import initialState from './initialState'

const selectors = createBasicSelectors(initialState, 'supplierFeedback')

export default { ...selectors }
